<template>
  <svg
    width="104"
    height="90"
    viewBox="0 0 104 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M51.5739 35.0541C61.2539 35.0541 69.101 27.207 69.101 17.5271C69.101 7.84714 61.2539 0 51.5739 0C41.894 0 34.0469 7.84714 34.0469 17.5271C34.0469 27.207 41.894 35.0541 51.5739 35.0541Z"
      fill="#CCCECE"
      fill-opacity="0.42"
    />
    <path
      d="M87.031 35.0542C93.1505 35.0542 98.1113 30.0934 98.1113 23.9739C98.1113 17.8544 93.1505 12.8936 87.031 12.8936C80.9115 12.8936 75.9507 17.8544 75.9507 23.9739C75.9507 30.0934 80.9115 35.0542 87.031 35.0542Z"
      fill="#CCCECE"
      fill-opacity="0.42"
    />
    <path
      d="M16.117 35.0542C22.2365 35.0542 27.1973 30.0934 27.1973 23.9739C27.1973 17.8544 22.2365 12.8936 16.117 12.8936C9.99745 12.8936 5.03662 17.8544 5.03662 23.9739C5.03662 30.0934 9.99745 35.0542 16.117 35.0542Z"
      fill="#CCCECE"
      fill-opacity="0.42"
    />
    <path
      d="M27.034 45.004C22.6724 41.4305 18.7223 41.9035 13.6792 41.9035C6.13649 41.9035 0 48.0038 0 55.5001V77.5016C0 80.7572 2.65726 83.4044 5.92496 83.4044C20.0324 83.4044 18.3329 83.6596 18.3329 82.796C18.3329 67.2058 16.4863 55.7727 27.034 45.004Z"
      fill="#CCCECE"
      fill-opacity="0.42"
    />
    <path
      d="M56.3706 41.9843C47.562 41.2496 39.9055 41.9928 33.3014 47.4439C22.2499 56.2961 24.3767 68.2151 24.3767 82.7962C24.3767 86.6539 27.5154 89.8513 31.4318 89.8513C73.9565 89.8513 75.649 91.2231 78.1707 85.6388C78.9977 83.7503 78.771 84.3504 78.771 66.2845C78.771 51.9352 66.3464 41.9843 56.3706 41.9843Z"
      fill="#CCCECE"
      fill-opacity="0.42"
    />
    <path
      d="M89.4691 41.903C84.3983 41.903 80.47 41.4348 76.1143 45.0035C86.5832 55.6922 84.8153 66.3452 84.8153 82.7955C84.8153 83.6646 83.4045 83.4039 97.0118 83.4039C100.396 83.4039 103.148 80.662 103.148 77.2916V55.4996C103.148 48.0033 97.0118 41.903 89.4691 41.903Z"
      fill="#CCCECE"
      fill-opacity="0.42"
    />
  </svg>
</template>

<script>
export default {
  name: 'GreyUsersIcon100'
};
</script>

<style scoped>

</style>